import ContentEditable from "react-contenteditable";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import style from "./Row.module.css";
import sanitizeHTML from "sanitize-html";
import { ref, remove, update } from "firebase/database";
import { db } from "../../../configs/Firebase";
import { useEffect, useRef, useState } from "react";
import Cell from "./Cell";

const Row = (props) => {
  function onChangeHandler(e) {
    // Extract plain text from HTML to prevent storing HTML markup
    let plainText = e.target.value;
    if (plainText) {
      const tmp = document.createElement("div");
      tmp.innerHTML = plainText;
      plainText = tmp.textContent || tmp.innerText || "";
      // Remove newlines to keep it single line
      plainText = plainText.replace(/\n/g, ' ').replace(/\r/g, '');
    }
    update(ref(db), {
      [props.journeyRefURL + "/rows/" + props.rowId + "/value"]: sanitizeHTML(
        plainText
      ),
    });
  }

  // Handle paste events to strip HTML and only allow plain text
  function handlePaste(e) {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text/plain');
    // Remove newlines to keep it single line
    const singleLineText = text.replace(/\n/g, ' ').replace(/\r/g, '');
    document.execCommand('insertText', false, singleLineText);
  }

  // Prevent Enter key to keep title on single line
  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  const [isDragging, setIsDragging] = useState(false);
  function onMouseDown() {
    setIsDragging(true);
  }

  const [rowSelected, setRowSelected] = useState(false);
  const onDragStart = (e, index) => {
    if (e.target.hasAttribute("data-row")) {
      props.isDraggingHandler(true);
      setRowSelected(true);
      props.setSelected({ el: e.target, index: index });
    }
  };

  const [hovered, setHovered] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const onDragOver = (e, index) => {
    if (
      props.selectedItem.index &&
      props.selectedItem.index !== index &&
      props.selectedItem.index + 1 !== index
    ) {
      e.preventDefault();
      setHovered(true);
    } else {
      setHovered(false);
    }
  };

  const onDragLeave = (e, index) => {
    setHovered(false);
  };

  const onDragDrop = (e, index) => {
    let isCell = e.target.closest("[data-cell]");
    if (!isCell) {
      let nearestTargetRow = e.target.closest("[data-row]");
      if (nearestTargetRow.hasAttribute("data-row")) {
        if (props.selectedItem.index !== index) {
          e.preventDefault();
          props.map.current.insertBefore(
            props.selectedItem.el,
            nearestTargetRow
          );
          props.reorder();
        }
      }
    }

    // if (e.target.hasAttribute("data-row")) {
    //   if (props.selectedItem.index !== index) {
    //     e.preventDefault();
    //     props.map.current.insertBefore(
    //       props.selectedItem.el,
    //       e.target.closest("[data-row]")
    //     );
    //     props.reorder();
    //   }
    // }
    setHovered(false);
  };

  const onDragEnd = (e, index) => {
    props.isDraggingHandler(false);
    setIsDragging(false);
    if (props.selectedItem.index !== index) {
      e.preventDefault();
    }
  };

  const [cells, setCells] = useState();

  useEffect(() => {
    // console.log("row changed", props.data);
    if (props.data && props.data.columns) {
      let tempCells = [];
      
      // Handle both array (from Firebase listener) and object (direct from Firebase)
      if (Array.isArray(props.data.columns)) {
        // Already an array, use it directly

        tempCells = props.data.columns.map((cell, index) => ({
          ...cell,
          id: cell.id || index.toString(),
          
        }));
      } else {
        // Convert object to array
        for (let i in props.data.columns) {
          let tempData = { ...props.data.columns[i] };
          // Preserve existing ID if it exists, otherwise use Firebase key
          tempData.id = tempData.id || i;
          tempCells.push(tempData);
        }
        // Sort by displayOrder to ensure correct order (Firebase stores arrays as objects)
        tempCells.sort((a, b) => {
          const orderA = a.displayOrder !== undefined ? a.displayOrder : parseInt(a.id);
          const orderB = b.displayOrder !== undefined ? b.displayOrder : parseInt(b.id);
          return orderA - orderB;
        });
      }
      setCells(tempCells);
    }
  }, [props.data?.columns]);

  function deleteRow() {
    // console.log(props.journeyRefURL + "/rows/" + props.data.id)

    if (
      window.confirm(
        "You are about to delete a whole row.  You will not be able to undo this action.  Do you wish to continue?"
      )
    ) {
      const rowRef = ref(db, props.journeyRefURL + "/rows/" + props.data.id);
      remove(rowRef);
      sleep(10);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <div
      className={`${style.row} ${isDragging && style.isDragging} ${
        props.type && style[props.type]
      } ${hovered && style.hovered} ${props.timeMachineMode && style.timeMachineMode}`}
      draggable={props.editable ? "true" : "false"}
      onDragStart={(e) => onDragStart(e, props.index)}
      onDragOver={(e) => onDragOver(e, props.index)}
      onDragLeave={(e) => onDragLeave(e, props.index)}
      onDragEnd={(e) => onDragEnd(e, props.index)}
      onDrop={(e) => onDragDrop(e, props.index)}
      data-id={props.rowId}
      data-row={true}
    >
      {props.blank ? null : (
        <div 
          className={style.name}
          onMouseEnter={() => props.editable && setShowDeleteButton(true)}
          onMouseLeave={() => setShowDeleteButton(false)}
        >
          <div className={style.inner}>
            {props.editable ? (
              <>
                <span className={style.handle} onMouseDown={onMouseDown}>
                  <Icon>drag_handle</Icon>
                </span>{" "}
                <ContentEditable
                  html={props.name}
                  onChange={(e) => onChangeHandler(e)}
                  onPaste={handlePaste}
                  onKeyDown={handleKeyDown}
                  inputMode="text"
                />
                {showDeleteButton && (
                  <button
                    type="button"
                    className={style.rowDeleteButton}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      deleteRow();
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    title="Delete row"
                  >
                    <Icon>close</Icon>
                  </button>
                )}
              </>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(props.name),
                }}
              />
            )}
          </div>
        </div>
      )}
      {props.children}

      {props.type === "stepNumber"
        ? [...Array(props.maxColumns)].map((v, index) => (
            <Cell
              key={index}
              first={index === 0 ? true : false}
              last={index + 1 === Array(props.maxColumns).length ? true : false}
              journeyRefURL={props.journeyRefURL}
              editable={false}
              data={{ value: index + 1 }}
              row={props.data}
              type={props.data.type}
              index={index}
              cellIndex={index}
              rowIndex={props.rowIndex}
              copyAndPaste={props.copyAndPaste}
              addRow={props.addRow}
              deleteRow={deleteRow}
              deleteCell={props.deleteCell}
            />
          ))
        : null}
      {cells &&
        cells.map((cell, index) => {
          // Use index for comment count key since columns are stored as array in Firebase
          const commentCountKey = `${props.rowId}_${index}`;
          const commentCount = props.cellCommentCounts?.[commentCountKey] || 0;
          const unreadCount = props.cellUnreadCounts?.[commentCountKey] || 0;
          
          return (
            <Cell
              key={index}
              first={index === 0 ? true : false}
              last={index + 1 === cells.length ? true : false}
              journeyRefURL={props.journeyRefURL}
              editable={props.editable}
              data={cell}
              row={props.data}
              type={props.data.type}
              index={index}
              cellIndex={index}
              rowIndex={props.rowIndex}
              copyAndPaste={props.copyAndPaste}
              addRow={props.addRow}
              onAddRowClick={props.onAddRowClick}
              deleteRow={deleteRow}
              deleteCell={props.deleteCell}
              onOpenComments={props.onOpenComments}
              commentCount={commentCount}
              unreadCount={unreadCount}
            />
          );
        })}
    </div>
  );
};

export default Row;
